import { FlexRow, SvgIcon, Text } from '@make-software/tg-mini-app-ui';
import styled, { useTheme } from 'styled-components';

import GiftIcon from '@/shared/assets/icons/ic-gift.svg';

interface PrizeBadgeProps {
  amount: number;
}

const Badge = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    alignItems: 'center',
    background: '#593D44',
    padding: '2px 4px',
    borderRadius: '4px',
    gap: '4px'
  })
);

export const PrizeBadge = ({ amount }: PrizeBadgeProps) => {
  const theme = useTheme();
  const formattedPrizeAmount = new Intl.NumberFormat('en-US').format(amount);
  return (
    <Badge>
      <SvgIcon src={GiftIcon} width={12} height={12} fillColor={theme.colors.mainRed} />
      <Text
        style={{ color: theme.colors.mainRed, fontSize: '11px', fontWeight: 400 }}
        monotype
      >{`${formattedPrizeAmount} CSPR`}</Text>
    </Badge>
  );
};
